export default "__VITE_ASSET__BjsD7cUz__"